import React, { useState } from 'react';
import { Card, Button, Form, Dimmer } from "tabler-react";
import { useFetch } from '../../lib/useFetch';
import Select from 'react-select';
import putObject from '../../lib/putObject';

const ShipmentAssignModal = ({ recordId, closeMainModal }) => {
  const { data: shipment, loading: shipmentLoading } = useFetch(`shipments/${recordId}`);
  const { data: trips, loading: tripsLoading } = useFetch(`shipments/${recordId}/matched-trips`);
  const [selectedTrip, setSelectedTrip] = useState(null)
  const [saveLoading, toggleSaveLoading] = useState(false)

  useState(() => {
    if (!tripsLoading && !shipmentLoading)
      setSelectedTrip(trips.find(t => t._id === shipment.tripId))
  }, [tripsLoading, shipmentLoading])

  const assignShipment = () => {
    toggleSaveLoading(true)
    putObject(`trips/${selectedTrip.value}/assignShipment`, { shipmentId: recordId }).then(() => {
      toggleSaveLoading(false)
      closeMainModal()
    })
  }

  return (
    <Card>
      <Dimmer active={shipmentLoading} loader={shipmentLoading}>
        <Card.Header>
          <Card.Title>Assign Shipment</Card.Title>
          <Card.Options>
            <Button
              size="sm"
              icon="x"
              onClick={() => closeMainModal()}
            />
          </Card.Options>
        </Card.Header>
        {!shipmentLoading && shipment &&
          <Card.Body>
            <Form>
              <Form.Label>Trips:</Form.Label>
              <Select
                value={selectedTrip}
                options={trips && trips.map(trip => {
                  const label = trip.flightInfo?.flightNo
                    || `${trip.fromCity?.name} → ${trip.toCity?.name}`;
                  return ({ label, value: trip['_id'] });
                })}
                isSearchable
                placeholder="Select trip"
                isLoading={tripsLoading}
                onChange={(e) => setSelectedTrip(e)}
              />
            </Form>
          </Card.Body>
        }
        <Card.Footer>
          <div style={{ textAlign: 'right' }}>
            <Button
              color="primary"
              size="sm"
              className={`ml-2 ${saveLoading ? 'btn-loading' : ''}`}
              onClick={() => assignShipment()}
              disabled={saveLoading}
            >
              Assign
            </Button>
            <Button
              color="secondary"
              size="sm"
              className="ml-2"
              onClick={() => closeMainModal()}
              disabled={saveLoading}
            >
              Cancel
            </Button>
          </div>
        </Card.Footer>
      </Dimmer>
    </Card>
  )
}

export default ShipmentAssignModal;
